/* eslint-disable import/prefer-default-export */

export const USER_LOGOUT_REQUEST = 'USER_LOGOUT_REQUEST';
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
export const USER_LOGOUT_FAILURE = 'USER_LOGOUT_FAILURE';
export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';
export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST';
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_REGISTER_FAILURE = 'USER_REGISTER_FAILURE';
export const CHANGE_FORM = 'CHANGE_FORM';
export const EDIT_PROFILE_REQUEST = 'EDIT_PROFILE_REQUEST';
export const EDIT_PROFILE_SUCCESS = 'EDIT_PROFILE_SUCCESS';
export const EDIT_PROFILE_FAILURE = 'EDIT_PROFILE_FAILURE';
export const PAGE_UNLOAD = 'PAGE_UNLOAD';
export const DEACTIVATE = 'DEACTIVATE';
export const PACKAGE_SINGLE = 1;
export const PACKAGE_MULTI = 2;
export const ROLE_SUPER_ADMIN = 1;
export const ROLE_EXECUTIVE_ADMIN = 2;
export const ROLE_SUBSCRIBERS_ADMIN = 3;
export const ROLE_MULTI_PACK_USER = 4;
export const ROLE_SINGLE_PACK_USER = 5;
export const ROLE_TRIAL_USER = 6;
export const EXPIRED_USER = 7;
export const RoleMap = {
  [ROLE_SUPER_ADMIN]: 'SUPER_ADMIN',
  [ROLE_EXECUTIVE_ADMIN]: 'EXECUTIVE_ADMIN',
  [ROLE_SUBSCRIBERS_ADMIN]: 'SUBSCRIBERS_ADMIN',
  [ROLE_MULTI_PACK_USER]: 'MULTI_PACK_USER',
  [ROLE_SINGLE_PACK_USER]: 'SINGLE_PACK_USER',
  [ROLE_TRIAL_USER]: 'TRIAL_USER',
  [EXPIRED_USER]: 'EXPIRED_USER'
};
export const QUERY = 'QUERY';
export const CHANGE_PATH = 'CHANGE_PATH';
export const MonthEnum = {
  JANUARY: 'January',
  FEBRUARY: 'February',
  MARCH: 'March',
  APRIL: 'April',
  MAY: 'May',
  JUNE: 'June',
  JULY: 'July',
  AUGUST: 'August',
  SEPTEMBER: 'September',
  OCTOBER: 'October',
  NOVEMBER: 'November',
  DECEMBER: 'December'
};
export const AgeEnum = {
  IT: '1-3 IT',
  PSC: '3-5 PSC/GD',
  OSC: '5-10 OSC'
};

export const AgeColors = {
  IT: '#E67E69',
  PSC: '#00B2A6',
  OSC: '#EFCA75',
  ALL: '#E02F2F'
};

export const ActivityType = {
  DAILY: 'daily',
  PROJECT: 'project'
};



// WEBPACK FOOTER //
// ./src/constants/index.js